export default "__VITE_ASSET__DgkUmJgE__ 400w, __VITE_ASSET__BTQ8R2wD__ 800w, __VITE_ASSET__Cv7gVsKL__ 1024w";